




































import Vue from "vue";

export default Vue.extend({
  i18nOptions: {
    keyPrefix: "views.imprint"
  }
});
